import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import { Dropdown } from 'components/dropdown'
import React, { SyntheticEvent } from 'react'
import { Publication } from 'types/publication'
import { IFilter } from 'types/IFilter'
import translations from 'locales/de.yml'
import { Age } from 'types/age'
import { Gender } from 'types/gender'
import { Education } from 'types/education'

type ClickHandler = (option: string | undefined, event?: SyntheticEvent) => void

export interface IFilterHandlers {
  handleAge: ClickHandler
  handleEducation: ClickHandler
  handleGender: ClickHandler
  handlePublication: ClickHandler
}

export interface IFilterOptions {
  availablePublications?: Publication[]
}

export function Filter({
  age,
  gender,
  publication,
  education,
  handleAge,
  handleGender,
  handleEducation,
  handlePublication,
  availablePublications = []
}: IFilter & IFilterHandlers & IFilterOptions) {
  /**
   * Create the options list. Pass in the name of the type
   *
   * @param list - The list to convert to option items
   */
  function createOptions(list: string[]) {
    return list
      .map(item => ({
        text: item,
        value: item
      }))
      .sort((a, b) => {
        return a.value.localeCompare(b.value, 'de-CH', { numeric: true })
      })
  }

  return (
    <div className={`ui top attached fitted segment filter`}>
      <h5 className='ui infographic header'>
        Daten filtern
        <div className='sub header'>
          Vergleichen Sie sich mit anderen Quizteilnehmern in verschiedenen
          Kategorien.
        </div>
      </h5>

      <div className='ui equal width form'>
        <div className='fields'>
          <div className='field'>
            <label>Alter</label>
            <Dropdown
              options={Object.values(Age).map(age => ({
                value: age,
                text: translations['Age'][age]
              }))}
              changeHandler={handleAge}
              currentValue={age}
              placeholderText={'Alle anzeigen'}
            />
          </div>

          <div className='field'>
            <label>Geschlecht</label>
            <Dropdown
              options={Object.values(Gender).map(gender => ({
                value: gender,
                text: translations['Gender'][gender]
              }))}
              changeHandler={handleGender}
              currentValue={gender}
              placeholderText={'Alle anzeigen'}
            />
          </div>
        </div>

        <div className='fields'>
          <div className='field'>
            <label>Bildung</label>
            <Dropdown
              options={Object.values(Education).map(edu => ({
                value: edu,
                text: translations['Education'][edu]
              }))}
              changeHandler={handleEducation}
              currentValue={education}
              placeholderText={'Alle anzeigen'}
            />
          </div>

          <div className='field'>
            <label>Publikation</label>
            <Dropdown
              options={createOptions(availablePublications as string[])}
              changeHandler={handlePublication}
              currentValue={publication}
              placeholderText={'Alle anzeigen'}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
